module.exports = ".head{\r\n    margin-top:10px;\r\n}\r\n\r\n.dashhead{\r\n    margin-top: 120px;\r\n}"